




























































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LoginForm extends Vue {
	private username: string = ''
	private password: string = ''
	private client: string = ''
	private errorMessage: string = ''

	private login() {
		this.$validator.validateAll().then((result) => {
			if (!result) {
				this.errorMessage = 'All form fields are required.'
				return
			}
			this.errorMessage = ''
			const login = {
				auth: { username: this.username, password: this.password },
				client: this.client,
			}
			this.$emit('login', login)
		})
	}
}
